import { render, staticRenderFns } from "./ocrReview.vue?vue&type=template&id=2f064adc&scoped=true&"
import script from "./ocrReview.vue?vue&type=script&lang=js&"
export * from "./ocrReview.vue?vue&type=script&lang=js&"
import style0 from "./ocrReview.vue?vue&type=style&index=0&id=2f064adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f064adc",
  null
  
)

export default component.exports